// Bama Billboards Company Configuration
// Update these values to reflect current company information

export const COMPANY_CONFIG = {
  // Company Information
  name: 'Bama Billboards',
  tagline: 'Calhoun County\'s Premier Outdoor Advertising Company',
  
  // Statistics
  stats: {
    yearsExperience: 3,
    billboardLocations: 4,
    citiesServed: 5,
    happyCustomers: 100
  },
  
  // Contact Information
  contact: {
    phone: '(256) 453-0164',
    phoneLink: '+12564530164',
    email: 'zach@bamabillboards.com',
    businessHours: 'Mon-Fri: 8AM-6PM',
    serviceArea: 'Calhoun County, Alabama'
  },
  
  // Service Areas
  serviceAreas: [
    'Anniston',
    'Oxford', 
    'Munford',
    'Talladega',
    'Eastaboga'
  ],
  
  // Social Media (update with actual URLs when available)
  socialMedia: {
    facebook: 'https://facebook.com',
    twitter: 'https://twitter.com',
    instagram: 'https://instagram.com'
  },
  
  // Company Description
  description: 'Calhoun County\'s premier outdoor advertising company, serving Anniston, Oxford, Munford, Talladega, and Eastaboga with the best billboard locations and rates.',
  
  // Company Story
  story: {
    founded: 'Founded with a vision to provide affordable, high-quality outdoor advertising solutions, Bama Billboards has been serving the Calhoun County area for over 15 years.',
    mission: 'We started with a simple mission: to help local businesses get their message out there without breaking the bank.',
    current: 'Today, we operate over 50 billboard locations across Anniston, Oxford, Munford, Talladega, and Eastaboga. Our strategic placements ensure maximum visibility for your advertising message, reaching thousands of potential customers every day.',
    commitment: 'We pride ourselves on our commitment to customer service, competitive pricing, and maintaining the highest quality standards in everything we do.'
  },
  
  // Company Values
  values: [
    {
      title: 'Customer Service',
      description: 'We prioritize our customers and provide personalized service for every advertising campaign.'
    },
    {
      title: 'Quality',
      description: 'We maintain the highest standards in billboard construction, maintenance, and customer service.'
    },
    {
      title: 'Strategic Locations',
      description: 'Our billboards are strategically placed in high-traffic areas for maximum visibility and impact.'
    },
    {
      title: 'Community Focus',
      description: 'We\'re proud to serve the Calhoun County community and support local businesses.'
    }
  ]
};

// Helper functions for formatting
export const formatPhone = (phone) => {
  return phone.replace(/\D/g, '');
};

export const formatPhoneDisplay = (phone) => {
  return phone.replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3');
};

// Export individual values for easy access
export const {
  name: COMPANY_NAME,
  tagline: COMPANY_TAGLINE,
  stats: COMPANY_STATS,
  contact: COMPANY_CONTACT,
  serviceAreas: SERVICE_AREAS,
  socialMedia: SOCIAL_MEDIA,
  description: COMPANY_DESCRIPTION,
  story: COMPANY_STORY,
  values: COMPANY_VALUES
} = COMPANY_CONFIG; 